import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import ContainerTemplate from 'templates/ContainerTemplate';
import Aside from 'components/organisms/Aside/Aside';
import BannerCarousel from 'components/molecules/Banners/BannerCarousel';

const StyledWrapper = styled.div`
	margin: 2rem 0;
`;

const ContentTemplate = ({ children }) => {
	const banners = useSelector((state) => state.banners);

	return (
		<StyledWrapper>
			<ContainerTemplate>
				<div className="row">
					<div className="col-12">
						{banners?.bannersTop && <BannerCarousel banners={banners.bannersTop} name="bannersTop" />}
					</div>
					<div className="col-lg-9">
						{children}

						<div className="mt-5">
							{banners?.bannersBottom && (
								<BannerCarousel banners={banners.bannersBottom} name="bannersBottom" />
							)}
						</div>
					</div>
					<div className="col-lg-3">
						<Aside />
					</div>
				</div>
			</ContainerTemplate>
		</StyledWrapper>
	);
};

ContentTemplate.propTypes = {
	children: PropTypes.element.isRequired,
};

export default ContentTemplate;
